import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { WorkflowTaskStatus, WorkflowTaskSummaryModel } from '../../model/common/workflowTaskSummary.model';
import { WorkflowTaskTriggerType } from '../../model/trigger/workflowTaskTrigger.model';
import { ErrorMessageResolver } from '../../../../../core/error/errorMessage.resolver';

@Component({
  selector: 'app-workflow-task-status-summary-field',
  templateUrl: './workflow-task-status-label.component.html',
})
export class WorkflowTaskStatusLabelComponent implements OnChanges {

  @Input() task: WorkflowTaskSummaryModel;
  WorkflowTaskStatus = WorkflowTaskStatus;
  WorkflowTaskTriggerType = WorkflowTaskTriggerType;
  errorLabel: string;

  constructor(private errorMessageResolver: ErrorMessageResolver) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['task'] && this.task) {
      if (this.task.errorCode) {
        this.errorLabel = this.errorMessageResolver.resolve(this.task.errorCode);
      }

    }
  }



}
